import Modal from 'react-bootstrap/Modal'
import * as React from 'react'
import EULA from './EULA'
import { FunctionComponent } from 'react'
import PrivacyPolicy from './PrivacyPolicy'

interface Props {
  show: boolean
  closeModal: () => void
  customPrivacyPolicy?: string
  companyName?: string
  gdprEmail: string
}

const PrivacyPolicyModal: FunctionComponent<Props> = (props: Props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.closeModal}
      centered={true}
      className="w-modal-eula"
      size="lg"
    >
      <Modal.Body>
        <div className="w-modal">
          <div className="container">
            <i
              className="fas fa-times modal-close"
              onClick={props.closeModal}
            />
            <PrivacyPolicy
              customPrivacyPolicy={props.customPrivacyPolicy}
              companyName={props.companyName}
              gdprEmail={props.gdprEmail}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default PrivacyPolicyModal
